import { render, staticRenderFns } from "./TermsConditionsFrontComponent.vue?vue&type=template&id=550ae44f&scoped=true"
import script from "./TermsConditionsFrontComponent.vue?vue&type=script&lang=js"
export * from "./TermsConditionsFrontComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550ae44f",
  null
  
)

export default component.exports